import React, { useState, useEffect, useContext, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "./../../components/panel/panel.jsx";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardHeader,
  CardFooter,
  Button,
} from "reactstrap";
import classnames from "classnames";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Config from "../../Config.js";
import swal from "sweetalert";
import ProfileCertificatesList from "../../pages/UserProfile/ProfileCertificatesList";
import SuppliersList from "../../pages/UserProfile/SuppliersList";
import SubloginList from "../../pages/UserProfile/SubloginList";
import Branding from "./Branding.js"
import { PageSettings } from "../../config/page-settings";
import UserWhatsApp from "./UserWhatsApp.js"
import {
  CheckStorageLimit,
  GetUsrLoginPackageDetail,
} from "../../api/packageApi";
import moment from "moment";

import { isValidPhoneNumber, isPossiblePhoneNumber } from 'react-phone-number-input';


const UserProfile = () => {
  let history = useHistory();
  console.log("loginRoleName=", localStorage.getItem("loginRoleName"));
  const context = useContext(PageSettings);
  const [rolename, setroleName] = useState(
    localStorage.getItem("loginRoleName")
  );
  const [activePill, setactivePill] = useState("1");
  const [UserID, setUserID] = useState("");
  const [SubloginId, setSubloginId] = useState("");
  const [CompanyID, setCompanyID] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyNameError, setCompanyNameError] = useState("");
  const [CompanyDescriptionError, setCompanyDescriptionError] = useState("");
  const [CompanyIndustryTypeError, setCompanyIndustryTypeError] = useState("");
  const [CompanyContactNoError, setCompanyContactNoError] = useState("");
  const [CompanyWebsiteError, setCompanyWebsiteError] = useState("");
  const [CompanyEmailError, setCompanyEmailError] = useState("");
  const [CompanyStreetError, setCompanyStreetError] = useState("");
  const [CompanyHouseNoError, setCompanyHouseNoError] = useState("");
  const [CompanyPostcodeError, setCompanyPostcodeError] = useState("");
  const [CompanyCityError, setCompanyCityError] = useState("");
  const [CompanyCountryError, setCompanyCountryError] = useState("");
  const [CompanyLogo, setCompanyLogo] = useState("");
  const [CompanyLogoPath, setCompanyLogoPath] = useState("");
  const [CompanyDescription, setCompanyDescription] = useState("");
  const [CompanyIndustryType, setCompanyIndustryType] = useState("");
  const [CompanyIndustryName, setCompanyIndustryName] = useState("");
  const [CompanyWebsite, setCompanyWebsite] = useState("");
  const [CompanyContactNo, setCompanyContactNo] = useState("");
  const [CompanyEmail, setCompanyEmail] = useState("");
  const [CompanyStreet, setCompanyStreet] = useState("");
  const [CompanyHouseNo, setCompanyHouseNo] = useState("");
  const [CompanyPostcode, setCompanyPostcode] = useState("");
  const [CompanyCity, setCompanyCity] = useState("");
  const [CompanyCountry, setCompanyCountry] = useState("");
  const [CompanyCountryName, setCompanyCountryName] = useState("");

  const [CountrydetailList, setCountrydetailList] = useState([]);

  const [IndustryTypeList, setIndustryTypeList] = useState([]);

  const [CurrentUserLoginName, setCurrentUserLoginName] = useState("");
  const [CurrentUserLoginEmail, setCurrentUserLoginEmail] = useState("");
  const [CurrentUserLoginPassword, setCurrentUserLoginPassword] = useState("");

  const [CurrentUserLoginRole, setCurrentUserLoginRole] = useState("");

  const [IsPublishedLogo, setIsPublishedLogo] = useState(false);
  const [PaggingList, setPaggingList] = useState([]);
  //label End

  const [UpgradepremiumLabel, setUpgradepremiumLabel] = useState(false);
  const [isshow, setisshow] = useState(false);


  const [PackageDetail, setPackageDetail] = useState(null);

  const [dayspending, setdayspending] = useState("");
  const [WhiteLabellingName, setWhiteLabellingName] = useState("");

  const [WhatsappNo, setWhatsappNo] = useState("");

  useEffect(() => {
    context.handleSetPageContentFullHeight(true);
    context.handleSetPageContentFullWidth(true);
    return () => {
      context.handleSetPageContentFullHeight(false);
      context.handleSetPageContentFullWidth(false);
    };
  }, []);

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === "" ||
      checkLogin === undefined ||
      checkLogin === null
    ) {
      return () => {
        history.push("/Login");
      };
    } else {
      setCompanyID(checkLogin);
      BindIndivualId(checkLogin);
      getAllCountryDropdownlist();
      //getIndustryTypelist();
      getUsrLoginPackageDetail();
    }
    //setCurrentUserLoginName(localStorage.getItem("loginName"));
  }, []);



  const getUsrLoginPackageDetail = async () => {
    let response = await GetUsrLoginPackageDetail();
    setPackageDetail(response);
    let enddate = new Date(
      response?.userPackageDetail?.endDate
        ? response?.userPackageDetail?.endDate
        : new Date()
    );
    let startDate = moment().format("YYYY-MM-DD");
    let enddateDate = moment(enddate).format("YYYY-MM-DD");
    let penidngdayes = moment(enddateDate).diff(moment(startDate), "days");
    if (penidngdayes >= 0) {
      setdayspending(penidngdayes);
    } else {
      setdayspending(-2);
    }
  };


  const BindIndivualId = async (loginUserID) => {
    let Auth0token = localStorage.getItem("Auth0token");
    if (loginUserID != null && loginUserID != "" && loginUserID != undefined) {
      fetch(Config.apiUrl + "UserCompany/ById?id=" + loginUserID, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
      }).then((resp1) => {
        resp1.json().then(async (result) => {
          if (result != null && result?._id !== null && result?._id !== "") {

            await getUserProfileImage();
            setCompanyName(result?.name);
            setCompanyDescription(result?.description);
            setCompanyWebsite(result?.website);
            setCompanyContactNo(result?.contactNo);
            setCompanyEmail(result?.email);
            setCompanyStreet(result?.street);
            setCompanyHouseNo(result?.houseNo);
            setCompanyPostcode(result?.postcode);
            setCompanyCity(result?.city);
            setCompanyCountry(result?.country);
            if (
              result?.country !== null &&
              result?.country !== "" &&
              result?.country !== undefined
            ) {
              setCompanyCountryName(result?.countryDetail?.name);
            }

            setCompanyID(result?._id);
            setCurrentUserLoginName(result?.name);
            setCurrentUserLoginEmail(result?.email);
            setIsPublishedLogo(result?.isPublishedLogo);
            setCurrentUserLoginPassword(result?.password);
            setWhatsappNo(result?.whatsappNo ? result?.whatsappNo : "");
            localStorage.setItem("loginName", result.name);

          } else {
            swal("User not Found");
          }
        });
      });
    }
  };

  const getAllCountryDropdownlist = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "GenericListing/DropdownList?categoryName=" + "Country",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        setCountrydetailList(result);
      });
    });
  };


  const onshow = (event) => {
    setisshow(true);
  };

  const togglePill = (pill) => {
    setisshow(false);

    let checkLogin = localStorage.getItem("loginUserID");
    if (pill === "1" && activePill !== pill) {
      BindIndivualId(checkLogin);
    } else if (pill === "2" && activePill !== pill) {
    } else if (pill === "3" && activePill !== pill) {
    } else if (pill === "4" && activePill !== pill) {
    } else if (pill === "5" && activePill !== pill) {
    } else if (pill === "6" && activePill !== pill) {
    }

    if (setactivePill !== pill) {
      setactivePill(pill);
    }
  };


  //API Start
  const CompanysetFile = (event) => {
    setCompanyLogoPath(URL.createObjectURL(event.target.files[0]));
    setCompanyLogo(event.target.files[0]);
  };


  const IsPublishedLogoupdate = (e) => {
    setIsPublishedLogo(e.target.checked);
  };
  const onChangeCompanyName = (event) => {

    setCompanyName(event.target.value);
    setCompanyNameError("");
  };
  const onChangeCompanyDescription = (event) => {
    setCompanyDescriptionError("");
    if (event.target.value.length >= 300) {
      setCompanyDescriptionError(
        "You have reached your maximum limit of characters allowed"
      );
    } else {
      setCompanyDescription(event.target.value);
    }
  };

  const onChangeCompanyWebsite = (event) => {
    setCompanyWebsiteError("");
    if (
      !/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9\-]+(\.[a-z\-]{2,}){1,3}(#?\/?[a-zA-Z0-9\-#]+)*\/?(\?[a-zA-Z0-9-_\-]+=[a-zA-Z0-9-%\-]+&?)?$/.test(
        event.target.value
      )
    ) {
      setCompanyWebsiteError("Invalid");
      setCompanyWebsite(event.target.value);
    } else {
      setCompanyWebsite(event.target.value);
    }
  };

  const onChangeCompanyContactNo = (event) => {
    setCompanyContactNo(event.target.value.replace(/[^\d+]/, ""));
    setCompanyContactNoError("");
  };

  const onChangeCompanyEmail = (event) => {
    setCompanyEmailError("");
    if (
      event.target.value === null ||
      event.target.value === undefined ||
      event.target.value === ""
    ) {
      setCompanyEmailError("Please Enter Email");
      setCompanyEmail(event.target.value);
    } else {
      if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(event.target.value)
      ) {
        setCompanyEmailError("Invalid email address");
        setCompanyEmail(event.target.value);
      } else {
        setCompanyEmail(event.target.value);
      }
    }
  };

  const onChangeCompanyStreet = (event) => {
    setCompanyStreetError("");
    if (event.target.value.length > 20) {
      setCompanyStreetError(
        "You have reached your maximum limit of characters allowed"
      );
    } else {
      setCompanyStreet(event.target.value);
    }
  };

  const onChangeCompanyHouseNo = (event) => {
    setCompanyHouseNo(event.target.value);
    setCompanyHouseNoError("");
  };

  const onChangeCompanyPostcode = (event) => {
    setCompanyPostcode(event.target.value);
    setCompanyPostcodeError("");
  };

  const onChangeCompanyCity = (event) => {
    setCompanyCityError("");
    if (event.target.value.length > 20) {
      setCompanyCityError(
        "You have reached your maximum limit of characters allowed"
      );
    } else {
      setCompanyCity(event.target.value);
    }
  };

  const onChangeCompanyCountry = (event) => {
    setCompanyCountry(event.target.value);
    setCompanyCountryError("");
  };
  const getUserProfileImage = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "FileUpload/?targetID=" +
      loginid +
      "&FileType=" +
      "profileimage",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null && result.length > 0) {
          setCompanyLogoPath(Config.contentUrl + result[0].filePath);
          localStorage.setItem(
            "loginUserImage",
            Config.contentUrl + result[0].filePath
          );
        } else {
          setCompanyLogoPath("");
          localStorage.setItem("loginUserImage", Config.contentUrl + "");
        }
      });
    });
  };

  const CreateProfileimage = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const byte = CompanyLogo.size;
    let StorageResponse = await CheckStorageLimit(byte);
    if (StorageResponse === false || StorageResponse === "false") {
      setCompanyLogo("");
      BindIndivualId(loginid);
      setisshow(false);
      swal(
        "Saved",
        "Sorry! Your profile details are updated and to update your image increase your storage limit.",
        "success"
      );
    } else {
      const formData = new FormData();
      formData.append("body", CompanyLogo);
      formData.append("fileType", "profileimage");
      formData.append("targetId", loginid);
      formData.append("externalLink", "");
      formData.append("displayOrder", "0");
      fetch(Config.apiUrl + "FileUpload/Update?id=" + "", {
        headers: {
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        method: "PUT",
        body: formData,
      }).then((result) => {
        result.json().then((resp) => {
          setCompanyLogo("");
          BindIndivualId(loginid);
          setisshow(false);
          swal("Saved", "User Profile  detail are Updated.", "success");
        });
      });
    }
  };
  const discardprofile = () => {
    clearform();
    let checkLogin = localStorage.getItem("loginUserID");
    BindIndivualId(checkLogin);
    setisshow(false);
  };
  const clearform = () => {
    setCompanyNameError("");
    setCompanyEmailError("");
    setCompanyDescriptionError("");
    setCompanyIndustryTypeError("");
    setCompanyStreetError("");
    setCompanyHouseNoError("");
    setCompanyWebsiteError("");
    setCompanyCountryError("");
    setCompanyCityError("");
    setCompanyPostcodeError("");
    setCompanyContactNoError("");
  };
  const UpdateCompanyDetail = () => {
    var retval = true;
    let checkLogin = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      CompanyName === null ||
      CompanyName === "" ||
      CompanyName === undefined
    ) {
      retval = false;
      setCompanyNameError("Please Enter Company Name");
    }
    if (CompanyEmail.length > 0) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(CompanyEmail)) {
        setCompanyEmailError("Invalid email address");
        retval = false;
      }
    }
    if (CompanyWebsite.length > 0) {
      if (
        !/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(
          CompanyWebsite
        )
      ) {
        setCompanyWebsiteError("Invalid");
        retval = false;
      }
    }
    if (retval === true) {
      let compnyData = {
        _id: CompanyID,
        Name: CompanyName,
        Email: CompanyEmail,
        Description: CompanyDescription,
        IndustryType: CompanyIndustryType,
        ContactNo: CompanyContactNo,
        Website: CompanyWebsite,
        Street: CompanyStreet,
        HouseNo: CompanyHouseNo,
        Postcode: CompanyPostcode,
        City: CompanyCity,
        Country: CompanyCountry,
        IsPublishedLogo: IsPublishedLogo,
        WhiteLabellingName: WhiteLabellingName
      };
      fetch(Config.apiUrl + "UserCompany/Update?id=" + CompanyID, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: CompanyID,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(compnyData),
      }).then((result) => {
        result.json().then(async (resp) => {
          if (resp != null) {

            if (CompanyLogo != null && CompanyLogo != "") {
              await CreateProfileimage();
            } else {
              if (resp._id != "" && resp._id != null) {
                BindIndivualId(checkLogin);
                setisshow(false);
                swal("Saved", "User Profile  detail are Updated.", "success");
              } else {
                swal("Sorry!", "email id allredy exite", "error");
              }
            }
          } else {
            swal("Sorry!", "User Profile not Updated.", "error");
          }
        });
      });
    }
  };

  const onChangewhatsappnumber = (e) => {
    // setWhatsappNo(e?.target.value);
    setWhatsappNo(e);
  }
  const Updatewhatsappnumber = async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (!checkLogin || !Auth0token) {
      history.push("/Login");
    }
    let isValid = isValidPhoneNumber(WhatsappNo);
    let ispossiblePhoneNumber = isPossiblePhoneNumber(WhatsappNo);
    if (!isValid || !ispossiblePhoneNumber) {
      return true;
    }
    const whatappbody = {
      "id": checkLogin,
      "WhatsappNo": WhatsappNo
    };
    try {
      const response = await fetch(`${Config.apiUrl}UserCompany/whatsappnumberupdate`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "userCompanyID": CompanyID,
          "Authorization": `Bearer ${Auth0token}`
        },
        body: JSON.stringify(whatappbody)
      });
      if (!response.ok) {
        throw new Error(`Failed to update. Status: ${response.status}`);
      }
      const resp = await response.json();
      if (resp) {
        swal("Saved", "Your whatsup number updated", "success");
        await BindIndivualId(checkLogin);
      } else {
        swal("Sorry!", "your whatsup number not updated.", "error");
      }
    } catch (error) {

      swal("Error", "Something went wrong. Please try again.", "error");
    }
  }
  return (
    <div>
      <div className="profile">
        <div className="profile-header">
          <div className="profile-header-cover"></div>
          <div className="profile-header-content">
            <div className="profile-header-img">
              <img
                src={CompanyLogoPath}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
              ></img>
            </div>
            <div className="profile-header-info">
              <h4 className="mt-0 mb-0">{CurrentUserLoginName}</h4>
              {CurrentUserLoginRole ? (
                <p className="mb-2">{CurrentUserLoginRole}</p>
              ) : (
                <></>
              )}
            </div>
          </div>

          <Nav className="profile-header-tab" pills>
            <NavItem>
              <NavLink
                className={classnames({ active: activePill === "1" })}
                onClick={() => {
                  togglePill("1");
                }}
              >
                <span className="d-sm-none">Profile</span>
                <span className="d-sm-block d-none ">Profile</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activePill === "7" })}
                onClick={() => {
                  togglePill("7");
                }}
              >
                <span className="d-sm-none">Branding</span>
                <span className="d-sm-block d-none ">Branding</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activePill === "3" })}
                onClick={() => {
                  togglePill("3");
                }}
              >
                <span className="d-sm-none">Certificates</span>
                <span className="d-sm-block d-none">Certificates</span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activePill === "4" })}
                onClick={() => {
                  togglePill("4");
                }}
              >
                <span className="d-sm-none">whatsapp</span>
                <span className="d-sm-block d-none">whatsapp</span>

              </NavLink>
            </NavItem>
          </Nav>
        </div>
      </div>
      <div className="content ml-0 profile-section">
        <TabContent className=" rounded  mb-4 mt-2 " activeTab={activePill}>
          <TabPane tabId="1">
            {isshow === false ? (
              <div className="table-responsive form-inline profile-content p-0">
                <table className="table table-profile">
                  <thead>
                    <tr classnames="username-container">
                      <th className="field">
                        {/* <img src="../assets/img/user/user-13.jpg" alt style={{ height: '40px', width: '40px', borderRadius: '5px' }} /> */}
                        <img
                          src={CompanyLogoPath}
                          style={{
                            height: "40px",
                            width: "40px",
                            borderRadius: "5px",
                            objectFit: 'cover'
                          }}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src =
                              "../assets/img/new-images/images.png";
                          }}
                        ></img>
                      </th>
                      <th>
                        <h4 className="mb-0">{CompanyName}</h4>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="field">Description</td>
                      {/* <td className='text'>{CompanyDescription}</td> */}

                      <td className="text">
                        {CompanyDescription ? CompanyDescription : "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="field">Industry Type</td>
                      {/* <td className='text'>{CompanyIndustryName}</td> */}
                      <td className="text">
                        {CompanyIndustryName ? CompanyIndustryName : "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="field">Website</td>
                      <td className="text">
                        {CompanyWebsite ? CompanyWebsite : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="field valign-middle">Contact Number</td>
                      <td className="text">
                        {CompanyContactNo ? CompanyContactNo : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="field valign-middle">Contact Email</td>

                      <td className="text">
                        {CompanyEmail ? CompanyEmail : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="field valign-middle">Street</td>

                      <td className="text">
                        {CompanyStreet ? CompanyStreet : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="field valign-middle">House Number</td>
                      <td className="text">
                        {CompanyHouseNo ? CompanyHouseNo : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="field valign-middle">PLZ / Post Code</td>
                      <td className="text">
                        {CompanyPostcode ? CompanyPostcode : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="field valign-middle">City</td>
                      {/* <td className='text'>
                                                    {CompanyCity}
                                                </td> */}
                      <td className="text">
                        {CompanyCity ? CompanyCity : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td className="field valign-middle">Country</td>
                      {/* <td className='text'>
                                                    {CompanyCountryName}
                                                </td> */}

                      <td className="text">
                        {CompanyCountryName ? CompanyCountryName : "N/A"}
                      </td>
                    </tr>
                    <tr className="divider">
                      <td colSpan="2"></td>
                    </tr>
                    <tr className="highlight">
                      <td className="field">&nbsp;</td>
                      <td className="p-t-10 p-b-10">
                        <button
                          type="submit"
                          className="btn btn-primary width-150"
                          onClick={onshow}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <Panel>
                <PanelHeader>
                  <h4 className="mb-0 text-light">My Profile</h4>
                </PanelHeader>
                <PanelBody className="p-0 bgwhite">
                  <div className="form-group row mb-0 profile-box p-0 mx-0 ">
                    <label className="col-xl-2 col-form-label left-border">
                      <h5 className="mb-0">Name</h5>
                    </label>
                    <div className="col-xl-5 py-3">
                      <input
                        type="text"
                        maxLength={30}
                        placeholder="Please Enter Company Name"
                        className="form-control input-design-1"
                        value={CompanyName}
                        onChange={onChangeCompanyName}
                      />
                      {CompanyNameError.length > 0 ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginLeft: "10px",
                          }}
                        >
                          {CompanyNameError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="form-group row mb-0 profile-box p-0 mx-0 ">
                    <label className="col-xl-2 col-form-label left-border">
                      <h5 className="mb-0">Logo</h5>
                    </label>
                    <div className="col-xl-2 d-flex align-items-center py-3">
                      <div className="custom-file file-upload-height">
                        {/* <input type="file" onChange={this.onChangeCompanyLogo} className="custom-file-input file-upload-height" id="customFile" /> */}
                        <input
                          type="file"
                          onChange={(e) => CompanysetFile(e)}
                          className="custom-file-input file-upload-height"
                          accept="image/x-png, image/gif, image/jpeg"
                          max-size="2000"
                        />
                        <label
                          className=" profile-upload-1 file-upload-height"
                          for="customFile "
                        >
                          {/* <img src={CompanyLogoPath} className="img-upload-size" /> */}
                          <img
                            src={CompanyLogoPath}
                            className="img-upload-size"
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src =
                                "../assets/img/new-images/images.png";
                            }}
                          ></img>
                          <div className="file-upload-3 ">
                            <i className="ion ion-md-camera  fa-sm"></i>
                          </div>
                        </label>
                      </div>
                      <div className="mt-2">
                        <input
                          type="checkbox"
                          value=""
                          id="RelatedCheckboxae1"
                          checked={IsPublishedLogo}
                          onChange={(e) => {
                            IsPublishedLogoupdate(e);
                          }}
                        />
                        <label htmlFor="RelatedCheckboxae1" className="ml-2">
                          {" "}
                          Publish
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-0 row profile-box p-0 mx-0 ">
                    <label className="col-xl-2 col-form-label left-border">
                      <h5 className="mb-0">Description</h5>
                    </label>
                    <div className="col-xl-5 py-3">
                      <textarea
                        className="form-control "
                        value={CompanyDescription}
                        rows="3"
                        maxLength={300}
                        placeholder="Enter short Description"
                        onChange={onChangeCompanyDescription}
                      ></textarea>
                      <p
                        style={{
                          textAlign: "right",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {CompanyDescription.length}/300
                      </p>
                      {CompanyDescriptionError.length > 0 ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginLeft: "10px",
                          }}
                        >
                          {CompanyDescriptionError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {/* <div className="form-group mb-0 row profile-box p-0 mx-0 ">
                    <label className="col-xl-2 col-form-label left-border">
                      <h5 className="mb-0">Industry Type</h5>
                    </label>
                    <div className="col-xl-5 py-3">
                      <select
                        value={CompanyIndustryType}
                        onChange={onChangeCompanyIndustryType}
                        className="default-select2 form-control  input-design"
                      >
                        <option value="">-- Select industry type --</option>
                        {IndustryTypeList.length > 0 &&
                          IndustryTypeList.map((Inditem, i) => (
                            <option value={Inditem.value} key={i}>
                              {Inditem.text}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div> */}
                  <div className="form-group row mb-0 profile-box p-0 mx-0 ">
                    <label className="col-xl-2 col-form-label left-border">
                      <h5 className="mb-0">Contact Info</h5>
                    </label>
                    <div className="col-xl-10 py-3">
                      <div className="row">
                        <div className="form-group col-md-6">
                          <label htmlFor="exampleInputEmail1">Website</label>
                          <input
                            type="url"
                            className="form-control input-design-1"
                            placeholder="Enter Website"
                            value={CompanyWebsite}
                            onChange={onChangeCompanyWebsite}
                          />
                          {CompanyWebsiteError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyWebsiteError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="exampleInputEmail1">
                            Contact Number
                          </label>
                          <input
                            type="text"
                            // maxLength="10"
                            className="form-control input-design-1"
                            placeholder="Enter Contact Number"
                            value={CompanyContactNo}
                            onChange={onChangeCompanyContactNo}
                          />
                          {CompanyContactNoError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyContactNoError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="row py-3">
                        <div className="form-group col-md-6">
                          <label htmlFor="exampleInputEmail1">
                            Contact Email
                          </label>
                          <input
                            readOnly={true}
                            type="email"
                            className="form-control input-design-1"
                            placeholder="Enter Email address"
                            value={CompanyEmail}
                            onChange={onChangeCompanyEmail}
                          />
                          {CompanyEmailError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyEmailError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0 mx-0   p-0">
                    <label className="col-xl-2 col-form-label left-border">
                      <h5 className="mb-0">Address</h5>
                    </label>
                    <div className="col-xl-10 py-3">
                      <div className="row">
                        <div className="form-group col-md-6">
                          <label htmlFor="exampleInputEmail1">Street</label>
                          <input
                            type="text"
                            // placeholder="Please Enter Company Name"
                            className="form-control input-design-1"
                            placeholder="Enter street address"
                            value={CompanyStreet}
                            onChange={onChangeCompanyStreet}
                          />
                          {CompanyStreetError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyStreetError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="exampleInputEmail1">
                            House Number
                          </label>
                          <input
                            type="text"
                            className="form-control input-design-1"
                            placeholder="Enter House Number"
                            value={CompanyHouseNo}
                            onChange={onChangeCompanyHouseNo}
                            maxLength={15}
                          />
                          <p
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "red",
                            }}
                          >
                            {CompanyHouseNo.length}/15
                          </p>
                          {CompanyHouseNoError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyHouseNoError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="exampleInputEmail1">
                            PLZ / Post Code
                          </label>
                          <input
                            type="text"
                            className="form-control input-design-1"
                            placeholder="Enter PLZ / Post Code"
                            value={CompanyPostcode}
                            maxLength={15}
                            onChange={onChangeCompanyPostcode}
                          />
                          <p
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "red",
                            }}
                          >
                            {CompanyPostcode.length}/15
                          </p>
                          {CompanyPostcodeError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyPostcodeError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6 ">
                          <label htmlFor="exampleInputEmail1">Country</label>
                          <select
                            className="default-select2 form-control  input-design"
                            value={CompanyCountry}
                            onChange={onChangeCompanyCountry}
                          >
                            <option value="" selected>
                              Select Country
                            </option>
                            {CountrydetailList.length > 0 ? (
                              CountrydetailList.map((d) => (
                                <option value={d.value}>{d.text}</option>
                              ))
                            ) : (
                              <></>
                            )}
                          </select>
                          {CompanyCountryError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyCountryError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="exampleInputEmail1">City</label>
                          <input
                            type="text"
                            className="form-control input-design-1"
                            placeholder="Enter City Name"
                            value={CompanyCity}
                            onChange={onChangeCompanyCity}
                          />
                          {CompanyCityError.length > 0 ? (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginLeft: "10px",
                              }}
                            >
                              {CompanyCityError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => UpdateCompanyDetail()}
                    className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                  >
                    Save Changes
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger shadow-add my-3 "
                    onClick={(e) => discardprofile()}
                  >
                    Discard
                  </button>
                </PanelBody>
              </Panel>
            )}
          </TabPane>
          <TabPane tabId="7">
            <Branding />
          </TabPane>

          <TabPane tabId="3">
            <h1 className="page-header">Certificates</h1>
            <ProfileCertificatesList />
          </TabPane>
          <TabPane tabId="4">
            <UserWhatsApp UserWhatsappNo={WhatsappNo} onChangewhatsappnumber={onChangewhatsappnumber} Updatewhatsappnumber={Updatewhatsappnumber} />
          </TabPane>

        </TabContent>
      </div>
    </div>
  );
};

export default UserProfile;
